import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27016715"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-banner-content flex-wrap text-gradient-light white-space-normal gutter-s2" }

import Icon from '@/components/icon/Icon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HodlBanner',
  emits: ["openDocs"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'openDocs'): void;
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    class: "button-banner w-full h-auto p-s3",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openDocs')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(Icon, {
          name: "thumbsUp",
          size: "20",
          class: "text-primary"
        }),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('yieldPool.hodlBannerText[0]')), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.$t('yieldPool.hodlBannerText[1]')), 1)
      ])
    ]),
    _: 1
  }))
}
}

})